// ==== action types ====

export const UPDATE_SUITABILITY_QUESTIONAIRE = 'UPDATE_SUITABILITY_QUESTIONAIRE'

export const UPDATE_SUITABILITY_SCORE = 'UPDATE_SUITABILITY_SCORE'

export const UPDATE_SUITABILITY_ANSWER = 'UPDATE_SUITABILITY_ANSWER'

export const UPDATE_SUITABILITY_STATUS = 'UPDATE_SUITABILITY_STATUS'

export const CLEAR_SUITABILITY_ANSWERS = 'CLEAR_SUITABILITY_ANSWERS'

// ==== action creators ====

export const updateSuitabilityQuestionaire = (suitabilityQuestionaire) => ({
  type: UPDATE_SUITABILITY_QUESTIONAIRE,
  payload: suitabilityQuestionaire,
})

export const updateSuitabilityAnswer = ({ questionCode, answerMode, answerChoice, optionalCode }) => ({
  type: UPDATE_SUITABILITY_ANSWER,
  payload: { questionCode, answerMode, answerChoice, optionalCode },
})

export const updateSuitabilityScore = (score) => ({
  type: UPDATE_SUITABILITY_SCORE,
  payload: score,
})

export const updateSuitabilityStatus = (status) => ({
  type: UPDATE_SUITABILITY_STATUS,
  payload: status,
})

export const clearSuitabilityAnswers = () => ({
  type: CLEAR_SUITABILITY_ANSWERS,
})
